import React, { useContext } from "react";
import { TextField } from "@material-ui/core";
//import { faKey } from '@fortawesome/pro-solid-svg-icons';
import { useFormik } from "formik";
import * as Yup from "yup";

import { UserContext } from "../../contexts/UserContext";
import { SubHeading } from "../ui/SubHeading";
import { Button } from "../ui/forms/Button";
import VpnKeyIcon from "@material-ui/icons/VpnKey";

const UserSettings = () => {
  const { changePassword } = useContext(UserContext);

  const { handleSubmit, handleChange, handleBlur, values, touched, errors } =
    useFormik({
      initialValues: {
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      },
      validationSchema: Yup.object({
        currentPassword: Yup.string().required("Enter your current password"),
        newPassword: Yup.string()
          .required(
            "Please enter a password 8 characters or longer, with at least one uppercase, one lowercase letter, a Number and a Special Character.",
          )
          //.matches( /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[$&+=?@#.^*()%!-]).{8,}$/)
          .matches(
            /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[$&+=?@#.^*()%!-])/,
            "Password must contact at least a Captial Letter, a Lowercase Letter, a Number and a Special Character",
          ),
        confirmNewPassword: Yup.string()
          .oneOf([Yup.ref("newPassword"), null])
          .required("Required"),
      }),
      onSubmit: async (values) => {
        await changePassword(
          values.currentPassword,
          values.newPassword,
          values.confirmNewPassword,
        );
      },
    });

  return (
    <>
      <SubHeading>
        {" "}
        <VpnKeyIcon style={Iconstyles} /> Change Password
      </SubHeading>
      <form onSubmit={handleSubmit}>
        <TextField
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.currentPassword}
          helperText={
            errors.currentPassword &&
            touched.currentPassword &&
            errors.currentPassword
          }
          name="currentPassword"
          label="Current Password"
          type="password"
          required
        />
        <TextField
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.newPassword}
          helperText={
            errors.newPassword && touched.newPassword && errors.newPassword
          }
          name="newPassword"
          label="New Password"
          type="password"
          required
        />
        <TextField
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.confirmNewPassword}
          helperText={
            errors.confirmNewPassword &&
            touched.confirmNewPassword &&
            errors.confirmNewPassword
          }
          name="confirmNewPassword"
          label="Confirm New Password"
          type="password"
          required
        />
        <Button colour="info" type="submit" margin="1rem 0 0 0">
          Change Password
        </Button>
      </form>
    </>
  );
};

const Iconstyles = {
  fontSize: "17px",
};

export default UserSettings;
